import React from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import {
  hide,
  selectIsOpen,
  selectMessage,
  selectType,
} from "redux/features/notice/noticeSlice"

import Snackbar from "components/ui/Snackbar"

const NoticeComponent = () => {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector((state) => selectIsOpen(state))
  const type = useAppSelector((state) => selectType(state))
  const message = useAppSelector((state) => selectMessage(state))

  const handleClose = () => {
    dispatch(hide())
  }

  return (
    <Snackbar
      open={isOpen}
      type={type}
      message={message}
      onClose={handleClose}
    />
  )
}

export default NoticeComponent
